import styled from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { theme } from "../theme/toyotaTheme";
import { legalStyle, type TextStyleType } from "../globals/Type";

export const Text = styled.div<TextStyleType & SpaceProps>`
    margin: ${theme.space[1]}px 0 ${theme.space[2]}px;
    color: ${theme.colors.grey4};
    ${legalStyle};
    ${space};
`;
